import React, { useState } from 'react';
import BugReportModal from './BugReportModal';

export default function ReportProblemLink() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button className="auth-site-btn-link" onClick={() => setOpen(true)} type="button">
        Report a Problem
      </button>
      {open && <BugReportModal onClose={() => setOpen(false)} />}
    </>
  );
}
